/** @jsxImportSource @emotion/react */
"use client";

import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { BreadcrumbNav } from "../BreadcrumbNav";
import {
  layoutContainer,
  heroImage,
  contentContainer,
  pageTitle,
} from "./styles";

interface CommonLayoutProps {
  title?: string;
  imageUrl?: string;
  children: ReactNode;
  subtitle?: string;
}

export default function CommonLayout({
  title,
  imageUrl,
  subtitle,
  children,
}: CommonLayoutProps) {
  return (
    <Box css={layoutContainer}>
      {imageUrl && (
        <Box css={heroImage}>
          <Image src={imageUrl} alt="hero" fill priority />
        </Box>
      )}
      <Box css={contentContainer}>
        <BreadcrumbNav title={title} />
        <Typography variant="h1" css={pageTitle}>
          {title}
        </Typography>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
        {children}
      </Box>
    </Box>
  );
}
